module.exports = __webpack_public_path__ + "static/img/wzry-companyProducts2.734b7df2.png";